import { queryOptions } from '@tanstack/react-query';
import type { HevitonApiAppLegacy } from '@heviton/heviton-api-app-legacy';
import { USER_ALARM_QUERY_KEY } from '@/shared/api';
import { fromRawAlarm } from '@/shared/data-mappers';
import type { AlarmItem } from '@/shared/data-types';

/**
 * user 알림 설정 query 정의 SSOT (queryKey + queryFn). `GET /users/me/alarm`.
 * queryFn = BE 호출 → `fromRawAlarm` 순수 변환. 검증 없음(계약 신뢰, ADR `domain-ssot` §5).
 */
export const userAlarmQueryOptions = (api: HevitonApiAppLegacy) =>
  queryOptions<AlarmItem[]>({
    queryKey: USER_ALARM_QUERY_KEY,
    queryFn: async ({ signal }) => fromRawAlarm(await api.user.getAlarm({ signal })),
  });
